import React from 'react';
import { FormProps, Modal, ModalBody } from 'react-bootstrap';
import BankingAccountForm, {
  BankingAccountDetails,
} from './BankingAccountForm';

export type customBankingAccountModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  existingBankingAccountDetails?: BankingAccountDetails;
  handleClose: () => void;
  handleSubmit: (formData: any) => void;
  formProps?: FormProps;
}>;

const BankingAccountFormModal = ({
  showModal = false,
  existingBankingAccountDetails,
  handleClose,
  handleSubmit,
  formProps,
  ...props
}: customBankingAccountModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="sm">
      <ModalBody className="pt-12">
        <BankingAccountForm
          existingBankingAccountDetails={existingBankingAccountDetails}
          handleClose={handleClose}
          handleOnSubmit={handleSubmit}
          {...formProps}
        />
      </ModalBody>
    </Modal>
  );
};

export default BankingAccountFormModal;
